import styled, { withTheme, DefaultTheme } from 'styled-components';
import Link from 'next/link';
import { Col, Row, Tag } from 'antd';

import { generateUrl } from '../../common/helpers/office.utils';
import useI18n from '../../common/hooks/useI18n';
import { IFlatWithOffice } from '../../common/model/flat.model';

type Props = {
  flat: IFlatWithOffice;
  className?: string;
  theme: DefaultTheme;
};

const StyledRow = styled(Row)`
  align-items: center;
`;

const Title = styled.span`
  font-size: 14px;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
  }
  font-weight: 600;
`;

const StyledTag = styled(Tag)`
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  cursor: pointer;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
  }
`;

const Info = styled.span`
  font-size: 14px;
  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
  }
`;

const OfficeInfoCard = ({ flat, className, theme }: Props): JSX.Element => {
  const i18n = useI18n();

  if (!flat.office) {
    return null;
  }

  return (
    <div className={className}>
      <StyledRow gutter={[16, 32]}>
        <Col flex="80px">
          <Title>{i18n.t('flat.office')}:</Title>
        </Col>
        <Col flex="auto">
          <Link href={generateUrl(flat.office)} legacyBehavior>
            <a>
              <StyledTag color={theme.colors.secondary}>
                {flat.office.name}
              </StyledTag>
            </a>
          </Link>
        </Col>
      </StyledRow>
      <StyledRow gutter={[16, 32]} style={{ marginTop: '16px' }}>
        <Col flex="80px">
          <Title>{i18n.t('office.phone')}:</Title>
        </Col>
        <Col flex="auto">
          <a href={`tel:${flat.office.phone}`}>
            <Info>{flat.office.phone}</Info>
          </a>
        </Col>
      </StyledRow>
    </div>
  );
};

export default withTheme<typeof OfficeInfoCard>(styled(OfficeInfoCard)`
  -webkit-box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 6px 21px -4px rgba(0, 0, 0, 0.25);
  border-radius: 32px;
  padding: 2rem;
`);
